import { render, staticRenderFns } from "./campaignSpending.vue?vue&type=template&id=37b3629e&scoped=true&"
import script from "./campaignSpending.vue?vue&type=script&lang=js&"
export * from "./campaignSpending.vue?vue&type=script&lang=js&"
import style0 from "./campaignSpending.vue?vue&type=style&index=0&id=37b3629e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b3629e",
  null
  
)

export default component.exports